import { combineReducers } from '@reduxjs/toolkit';
import { authReducer } from './authReducer';
import { processReducer } from './processReducer';

// Combine reducers
const rootReducer = combineReducers({
  auth: authReducer,
  process: processReducer
});

export default rootReducer;